<template lang="pug">
.new-vendor
  .new-vendor__process(v-if="data.basic.process_status !== 3")
    .new-vendor__process__items
      .new-vendor__process__item(:class="{ 'active': !isEdit,'finish':data.basic.process_status >= 1 }")
        span
          i.iconfont.icon-checkmark(v-if="data.basic.process_status >= 1")
          template(v-else) 1
        span {{ $t('联合利华创建供应商账号') }}
      .new-vendor__process__divider(:class="{ 'finish': data.basic.process_status >= 1}")
      .new-vendor__process__item(:class="{'active':data.basic.process_status === 1, 'finish':data.basic.process_status >= 2}")
        span
          i.iconfont.icon-checkmark(v-if="data.basic.process_status >= 2")
          template(v-else) 2
        span {{ $t('供应商设置密码激活账号')  }}
      .new-vendor__process__divider(:class="{ 'finish': data.basic.process_status >= 2}")
      .new-vendor__process__item(:class="{'active':data.basic.process_status === 2}")
        span
          i.iconfont.icon-checkmark(v-if="data.basic.process_status === 3")
          template(v-else) 3
        span {{ $t('供应商完整信息入库') }}
  el-form(
    v-loading="loading"
    :model="form"
    :rules="rules"
    ref="form"
    label-width="150px"
    :class="['new-vendor', data.basic.process_status !== 3 ? 'show-vendor-process' : '']"
  )
    h1(style="font-size: 20px; margin-left: 20px") {{ isEdit ? $t('编辑供应商') : $t('新增供应商') }}

    title-bar(style="margin-bottom: 20px") {{ $t('供应商信息') }}

    div(style="margin-left: 20px")
      el-form-item(:label="$t('供应商中文名称')" prop="vendor_name_ch")
        el-input(v-model="form.vendor_name_ch")

      el-form-item(:label="$t('供应商英文简称')" prop="vendor_name")
        el-input(v-model="form.vendor_name")

      el-form-item(:label="$t('是否为总库供应商')" prop="is_total_vendor")
        el-radio(v-model="form.is_total_vendor" :label="1") {{ $t('是') }}
        el-radio(v-model="form.is_total_vendor" :label="0") {{ $t('否') }}

      el-form-item(v-if="form.is_total_vendor === 1" :label="$t('供应商ID')" prop="vendor_internal_id")
        el-input(v-model="form.vendor_internal_id")

      el-form-item(
        :label="$t('供应商服务大类')"
        required
      )
        select-campaign-category(
          ref="category"
          v-model="categories"
          :showLabel="false"
          :showRoster="form.is_total_vendor === 1 && isPurchase"
          :roster="roster"
        )

    title-bar(style="margin-bottom: 20px") {{ $t('账号信息') }}

    div(style="margin-left: 20px")
      el-form-item(:label="$t('登录邮箱')" prop="mail")
        el-input(v-model="form.mail")

      el-form-item(:label="$t('联系人姓名')" prop="name")
        el-input(v-model="form.name")

      el-form-item(:label="$t('性别')" prop="gender")
        el-radio(v-model="form.gender" :label="1") {{ $t('男') }}
        el-radio(v-model="form.gender" :label="0") {{ $t('女') }}

      el-form-item(:label="$t('职位')" prop="title")
        el-input(v-model="form.title")

      el-form-item(:label="$t('手机')" prop="phone_mobile")
        el-input(v-model="form.phone_mobile")

      el-form-item(:label="$t('座机')" prop="phone_office")
        el-input(v-model="form.phone_office")

      el-form-item
        el-button(type="primary" @click="onSave") {{ $t('提交') }}
        el-button(@click="onCancel") {{ $t('取消') }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import SelectCampaignCategory from '@/components/SelectCampaignCategory'
import axios from 'axios'
import { format4backend, validateEmail } from '@/umcc/util'

const formEmailValidator = (rule, value, callback) => !validateEmail(value) && callback(new Error(this.$t('邮箱不合法')))

export default {
  components: {
    TitleBar,
    SelectCampaignCategory
  },
  data () {
    return {
      data: {
        basic: {}
      },
      form: {
        vendor_name: '',
        vendor_name_ch: '',
        is_total_vendor: 1,
        vendor_internal_id: '',
        name: '',
        gender: 1,
        title: '',
        phone_mobile: '',
        phone_office: '',
        mail: ''
      },
      rules: {
        vendor_name: [ { required: true, message: this.$t('请输入供应商英文简称'), trigger: 'blur' } ],
        vendor_name_ch: [ { required: true, message: this.$t('请输入供应商中文名称'), trigger: 'blur' } ],
        is_total_vendor: [ { required: true } ],
        vendor_internal_id: [ { required: true, message: this.$t('请输入供应商ID'), trigger: 'blur' } ],
        mail: [ { required: true, message: this.$t('请输入正确的登录邮箱'), trigger: 'blur', validator: formEmailValidator } ],
        name: [ { required: true, message: this.$t('请输入联系人姓名'), trigger: 'blur' } ],
        gender: [ { required: true, message: this.$t('请选择性别'), trigger: 'blur' } ],
        title: [ { required: true, message: this.$t('请输入职位'), trigger: 'blur' } ],
        phone_mobile: [ { required: true, message: this.$t('请输入手机'), trigger: 'blur' } ]
      },
      categories: [],
      loading: false,
      roster: [false, false, false], // 对应 digital design IT的roster
      userId: null,
      originalMail: null // 用来对比编辑时邮箱是否有更改
    }
  },
  computed: {
    vendorId () {
      return this.$route.query.id
    },
    isEdit () {
      return this.vendorId != null
    },
    isPurchase () {
      return this.$store.state.common.user.struct_group_type === '20'
    }
  },
  mounted () {
    if (this.isEdit) this.fetchVendorInfo()
  },
  methods: {
    async fetchVendorInfo () {
      this.loading = true
      try {
        const res = await axios.get('/vendor/vendor/getVendorInfo', {
          params: { vendor_id: this.vendorId }
        })
        this.data = res
        this.form.vendor_name = res.basic.vendor_name
        this.form.vendor_name_ch = res.basic.vendor_name_ch
        this.form.is_total_vendor = res.basic.is_total_vendor
        this.form.vendor_internal_id = res.basic.vendor_internal_id
        this.form.mail = res.user.mail
        this.originalMail = res.user.mail
        this.form.name = res.user.user_name
        this.form.gender = res.user.gender
        this.form.title = res.user.position
        this.form.phone_mobile = res.user.phone_mobile
        this.form.phone_office = res.user.phone_office
        this.userId = res.user.user_id
        this.categories = res.category
        this.roster = [
          res.category.find(i => i.category_id === 1) ? res.category.find(i => i.category_id === 1).is_storage === 1 : false,
          res.category.find(i => i.category_id === 2) ? res.category.find(i => i.category_id === 2).is_storage === 1 : false,
          res.category.find(i => i.category_id === 5) ? res.category.find(i => i.category_id === 5).is_storage === 1 : false
        ]
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error)
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onSave () {
      const params = this.getParams()
      if (params == null) return
      if (params.includes('vendor.is_total_vendor=1') && !params.includes('vendor_internal_id')) return

      this.loading = true

      if (!this.isEdit) {
        let res = null
        try {
          res = await axios.post('/vendor/client/saveVendor', params)
          this.loading = false
        } catch (error) {
          this.loading = false
        }
        if (res.status === 1) {
          this.$confirm(
            this.$t('已成功创建供应商账号！供应商联系人将会收到系统邮件，设置登录密码！'),
            this.$t('新建成功'),
            { showCancelButton: false }
          ).then(() => {
            if (this.isEdit) {
              this.$router.go(-1)
              return
            }
            this.$router.push('/vendor/list')
          })
        } else {
          this.$confirm(
            this.$t('供应商邮箱地址有误，请确认邮箱地址准确性！'),
            this.$t('新建失败'),
            { showCancelButton: false }
          )
        }
      } else {
        try {
          await axios.post('/vendor/client/updateVendor', params)
          this.loading = false
          this.$message.success(this.$t('更新成功'))
          this.$router.go(-1)
        } catch (err) {
          this.loading = false
          throw new Error(err)
        }
      }
    },
    getParams () {
      const ids = this.$refs.category.mapValueToId(this.categories)

      if (Object.keys(ids).length === 0) {
        this.$message.error(this.$t('请选择供应商服务大类'))
        throw new Error()
      }

      this.categories.forEach(item => {
        // skip IT and Adv./Digital Production
        if (Number(item.category_id) === 5 || Number(item.category_id) === 3) return

        if (item.scope_id == null) {
          this.$message.error(this.$t('请选择对应的scope'))
          throw new Error()
        }
      })

      const getIsStorage = id => {
        if ([1, 2, 5].includes(id)) {
          switch (id) {
            case 1:
              return this.roster[0] ? 1 : 0
            case 2:
              return this.roster[1] ? 1 : 0
            case 5:
              return this.roster[2] ? 1 : 0
          }
        }
        return 0
      }

      const vendorCategory = Object.keys(ids).map(id => ({
        category_id: id,
        is_storage: getIsStorage(Number(id))
      }))
      const vendorScope = vendorCategory
        .map(item => ids[item.category_id].map(i => ({ scope_id: i })).filter(i => i.scope_id != null))

      // element validate 如果成功不会返回resolved ?
      // 下面手动校验下表单
      this.$refs.form.validate()

      // 手动检验
      const f = this.form

      if ([
        f.vendor_name,
        f.vendor_name_ch,
        f.mail,
        f.name,
        f.title,
        f.phone_mobile,
        f.gender
      ].some(i => i == null || i === '')) return null

      const params = {
        vendor: {
          vendor_name: f.vendor_name,
          vendor_name_ch: f.vendor_name_ch,
          is_total_vendor: f.is_total_vendor,
          vendor_internal_id: f.vendor_internal_id
        },
        user: {
          mail: f.mail,
          user_name: f.name,
          gender: f.gender,
          position: f.title,
          phone_mobile: f.phone_mobile,
          phone_office: f.phone_office
        },
        vendor_category: vendorCategory,
        vendor_scope: vendorScope
      }
      if (this.isEdit) {
        params.vendor.vendor_id = this.vendorId
        if (f.mail === this.originalMail) {
          params.user.user_id = this.userId
        }
      }

      return format4backend(params)
    }
  }
}
</script>

<style lang="stylus" scoped>
.new-vendor .el-input
  width 180px

.select-campaign-category
  margin-top -30px

button.el-button--mini
  padding 4px 45px
.show-vendor-process
 padding-top 150px
.new-vendor__process
  text-align center
  display flex
  justify-content center
  height 111px
  background #ffffff
  border-radius 3px
  box-shadow 0 2px 4px 0 rgba(74, 83, 96, 0.12)
  margin-top -16px
  position fixed
  width calc(100% - 200px)
  margin-left -32px
  z-index 999
.new-vendor__process__items
  display flex
  justify-content space-around
  align-items center
  .new-vendor__process__item
    color #808080
    display flex
    align-items center
    line-height 30px
    span
      &:nth-child(1)
        border 1px solid rgba(0, 0, 0, 0.15)
        height 30px
        width 30px
        display inline-block
        border-radius 50%
        margin-right 8px
        i
          font-size 24px
  .new-vendor__process__item.active
    color rgba(0, 0, 0, 0.85)
    span
      &:nth-child(1)
        border 1px solid #1890ff
        height 30px
        width 30px
        background #1890ff
        color #ffffff
  .new-vendor__process__item.finish
    color rgba(0, 0, 0, 0.65)
    span
      &:nth-child(1)
        border-color #1890ff
        color $main
  .new-vendor__process__divider
    width 114px
    height 1px
    background-color rgba(0, 0, 0, 0.15)
    margin 0 14px
  .new-vendor__process__divider.finish
    background #1890ff
</style>
